import React from 'react'

import { applyStyle } from '../helpers/styles'
import { formatColorProps } from '../helpers/colors'
import { useColor, useTinyColor } from '../../components/theme/_hooks/colors'
import { useTheme } from '../../components/theme/ThemeHandler'

export const useBackgroundStyle = props => {
  const theme = useTheme()
  const { bgColor, hoverBgColor, shadow, shadowTransparency } = formatColorProps(props, theme)
  const bgColorValue = useColor(bgColor)
  const hoverBgColorValue = useColor(hoverBgColor)
  const shadowValue = useTinyColor(shadow)
    .setAlpha(shadowTransparency || 0.5)
    .toRgbString()

  return React.useMemo(() => {
    return `
      ${applyStyle('background-color', bgColorValue)}
			${applyStyle('box-shadow', shadow, `0 0 8px 0 ${shadowValue}`)};
			&:hover {
				${applyStyle('background-color', hoverBgColorValue)}
			}
    `
  }, [bgColorValue, hoverBgColorValue, shadowValue, shadow])
}
